import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { ValidationService } from '../validation.service';

@Component({
  selector: 'app-registered-drivers',
  templateUrl: './registered-drivers.component.html',
  styleUrls: ['./registered-drivers.component.scss']
})
export class RegisteredDriversComponent implements OnInit {
  @ViewChild('registerDriverDialog', { static: true }) registerDriverDialog: TemplateRef<any>;

  constructor(private dialog: MatDialog, private http: HttpService, private snackbar: SnackbarService, private valid: ValidationService) { }
  drivers: any = [
    { no: 1, nationality: '123abc', name: '12345', licenseExpiry: 'red', refKey: '1234567', actions: '' },
    { no: 2, nationality: '123abc', name: '12345', licenseExpiry: 'red', refKey: '1234567', actions: '' },
    { no: 3, nationality: '123abc', name: '12345', licenseExpiry: 'red', refKey: '1234567', actions: '' },
  ];
  showLoader = false;
  displayedColumns = ['no', 'nationality', 'name', 'licenseExpiry', 'refKey', 'actions'];
  registerDriverDialogRef: any;
  dataToSend: any = {};
  driverArr = [];
  ngOnInit() {

  }
  openupdateFreightDialog() {
    this.getDrivers();
    this.registerDriverDialogRef = this.dialog.open(this.registerDriverDialog);
  }
  getDrivers() {
    this.showLoader = true;
    this.http.get('driver/get_all', {}).subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data.statusCode == 200) {
          const driverArray = data.data.drivers;

          this.driverArr = [];

          driverArray.forEach((element) => {

            const temp: any = {};
            temp._id = element._id;
            temp.driverName = element.name;
            temp.driverMobile = element.mobile;

            this.driverArr.push(temp);
          });
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  closeDialog() {
    this.registerDriverDialogRef.close();
  }
  selectDriver(driver, event) {
    if (event.source._selected) {
      this.dataToSend.driver_id = driver._id;
      this.dataToSend.mobileNumber = driver.driverMobile;
    }
  }

}
